import { PlanType } from './../../enums/user';
export class SignUpModel {
    FirstName: string;
    LastName: string;
    EmailId: string;
    Password: string;
    PlanType: PlanType;
    AccountName: string;
    Role: number;
    Mobile: string;

    constructor() {
        this.FirstName = '';
        this.LastName = '';
        this.EmailId = '';
        this.Password = '';
        this.PlanType = PlanType.Basic;
        this.AccountName = '';
        this.Role = 0;
        this.Mobile = '';
    }
}
